let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eDLSA")).then(() => parcelRequire('lqPYT'));